import { GetterTree } from 'vuex';
import { RootState } from '@/store';

import { State } from './state';

export type Getters = {
  getObraSelecionada(state: State): any | null;
  getCodigoContrato(state: State): any | null;
  getContratosUsuario(state: State): any[];
  getObrasUsuario(state: State): any[];
};

export const getters: GetterTree<State, RootState> & Getters = {
  getObraSelecionada: (state) => state.obraSelecionada,
  getCodigoContrato: (state) => state.codigoContrato,
  getContratosUsuario: (state) => state.contratosUsuario,
  getObrasUsuario: (state) => state.obrasUsuario
};
